import axios from "axios";
import { baseUrl } from "@app/providers";



export async function createUser(params: any) {
  const bodyFormData = new FormData();
  for (const key in params) {
    bodyFormData.append(key, params[key]);
  }
  return axios({
    method: "POST",
    url: baseUrl + `users/createUser`,
    data: bodyFormData,
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  })
    .then((res: any) => {
      const response = res.data;
      return response;
    })
    .catch((err: any) => {
      console.log(err, "CreateUserError");
    });
}

export async function logoutUser(params: any) {
  const bodyFormData = new FormData();
  for (const key in params) {
    bodyFormData.append(key, params[key]);
  }
  return axios({
    method: "POST",
    url: baseUrl + `users/logout`,
    data: bodyFormData,
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  })
    .then((res: any) => {
      const response = res.data;
      return response;
    })
    .catch((err: any) => {
      console.log(err, "LogOutError");
    });
}

export async function logInUser(params: any) {
  const bodyFormData = new FormData();
  for (const key in params) {
    bodyFormData.append(key, params[key]);
  }
  return axios({
    method: "POST",
    url: baseUrl + `users/login`,
    data: bodyFormData,
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  })
    .then((res: any) => {
      const response = res.data;
      return response;
    })
    .catch((err: any) => {
      console.log(err, "LoginError");
    });
}

export async function getSchoolDetails(params: any) {
  const bodyFormData = new FormData();
  for (const key in params) {
    bodyFormData.append(key, params[key]);
  }
  return axios({
    method: "POST",
    url: baseUrl + `users/getSchoolAccountDetails`,
    data: bodyFormData,
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  })
    .then((res: any) => {
      const response = res.data;
      return response;
    })
    .catch((err: any) => {
      console.log(err, "SchoolDetailsError");
    });
}

export async function updateUser(params: any) {
  const bodyFormData = new FormData();
  for (const key in params) {
    bodyFormData.append(key, params[key]);
  }
  return axios({
    method: "POST",
    url: baseUrl + `users/updateUser`,
    data: bodyFormData,
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  })
    .then((res: any) => {
      const response = res.data;
      return response;
    })
    .catch((err: any) => {
      console.log(err, "UpdateUserError");
    });
}

export async function uploadImage(params: any) {
  return axios({
    method: "POST",
    url: baseUrl + `users/uploadAsset`,
    data: params,
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  })
    .then((res: any) => {
      const response = res.data;
      return response;
    })
    .catch((err: any) => {
      console.log(err, "UploadImageError");
    });
}

export async function validateEmail(params: any) {
  const bodyFormData = new FormData();
  for (const key in params) {
    bodyFormData.append(key, params[key]);
  }
  return axios({
    method: "POST",
    url: baseUrl + `users/checkEmail`,
    data: bodyFormData,
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  })
    .then((res: any) => {
      const response = res.data;
      return response;
    })
    .catch((err: any) => {
      console.log(err, "ValidateEmailError");
    });
}

export async function deleteAccount(params: any) {
  const bodyFormData = new FormData();
  for (const key in params) {
    bodyFormData.append(key, params[key]);
  }
  return axios({
    method: "POST",
    url: baseUrl + `users/deleteParentChildAccount`,
    data: bodyFormData,
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  })
    .then((res: any) => {
      const response = res.data;
      return response;
    })
    .catch((err: any) => {
      console.log(err, "DeleteError");
    });
}

export async function linkParentChild(params: any) {
  const bodyFormData = new FormData();
  for (const key in params) {
    bodyFormData.append(key, params[key]);
  }
  return axios({
    method: "POST",
    url: baseUrl + `users/linkParentChildAccount`,
    data: bodyFormData,
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  })
    .then((res: any) => {
      const response = res.data;
      return response;
    })
    .catch((err: any) => {
      console.log(err, "LinkParentChild");
    });
}

export async function submitContent(params: any) {
  const bodyFormData = new FormData();
  for (const key in params) {
    bodyFormData.append(key, params[key]);
  }
  return axios({
    method: "POST",
    url: baseUrl + `users/sendSubmitContentEmail`,
    data: bodyFormData,
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  })
    .then((res: any) => {
      const response = res.data;
      return response;
    })
    .catch((err: any) => {
      console.log(err, "SubmitContentError");
    });
}

export async function educatorSchoolAcount(params: any) {
  const bodyFormData = new FormData();
  for (const key in params) {
    bodyFormData.append(key, params[key]);
  }
  return axios({
    method: "POST",
    url: baseUrl + `users/createSchoolAccount`,
    data: bodyFormData,
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  })
    .then((res: any) => {
      const response = res;
      return response;
    })
    .catch((err: any) => {
      console.log(err, "EducatorSchoolAccount");
    });
}

export async function resetPassword(params: any) {
  const bodyFormData = new FormData();
  for (const key in params) {
    bodyFormData.append(key, params[key]);
  }
  return axios({
    method: "POST",
    url: baseUrl + `users/resetPassword`,
    data: bodyFormData,
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  })
    .then((res: any) => {
      const response = res.data;
      return response;
    })
    .catch((err: any) => {
      console.log(err, "Reset Password");
    });
}

export async function forgotPassword(params: any) {
  const bodyFormData = new FormData();
  for (const key in params) {
    bodyFormData.append(key, params[key]);
  }
  return axios({
    method: "POST",
    url: baseUrl + `users/forgotPassword`,
    data: bodyFormData,
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  })
    .then((res: any) => {
      const response = res.data;
      return response;
    })
    .catch((err: any) => {
      console.log(err, "Forgot Password");
    });
}

export async function getAddress(param: any) {
  return axios({
    method: "get",
    url: `https://ziptasticapi.com/${param}`,
    responseType: "json",
  })
    .then((res: any) => {
      const response = res.data;
      return response;
    })
    .catch((err: any) => {
      console.log(err, "Zip Code Error");
    });
}

export async function getUser(params: any) {
  const bodyFormData = new FormData();
  for (const key in params) {
    bodyFormData.append(key, params[key]);
  }
  return axios({
    method: "POST",
    url: baseUrl + `users/getUser`,
    data: bodyFormData,
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  })
    .then((res: any) => {
      const response = res.data;
      return response;
    })
    .catch((err: any) => {
      console.log(err, "Get User Error");
    });
}

export async function sendOtp(params: any) {
  const bodyFormData = new FormData();
  for (const key in params) {
    bodyFormData.append(key, params[key]);
  }
  return axios({
    method: "POST",
    url: baseUrl + `users/sendOtp`,
    data: bodyFormData,
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  })
    .then((res: any) => {
      const response = res.data;
      return response;
    })
    .catch((err: any) => {
      console.log(err, "Get OTP Error");
    });
}

export async function sendAuthEmail(params: any) {
  const bodyFormData = new FormData();
  for (const key in params) {
    bodyFormData.append(key, params[key]);
  }
  // return {_responseStatus : 1}
  return axios({
    method: "POST",
    url: baseUrl + `users/sendAuthEmail`,
    data: bodyFormData,
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  })
    .then((res: any) => {
      const response = res.data;
      return response;
    })
    .catch((err: any) => {
      console.log(err, "Get OTP Error");
    });
}

export async function validateOtp(params: any) {
  const bodyFormData = new FormData();
  for (const key in params) {
    bodyFormData.append(key, params[key]);
  }
  return axios({
    method: "POST",
    url: baseUrl + `users/validateOtp`,
    data: bodyFormData,
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  })
    .then((res: any) => {
      const response = res.data;
      return response;
    })
    .catch((err: any) => {
      console.log(err, "Get OTP Error");
    });
}

export async function createClass(params: any) {
  const bodyFormData = new FormData();
  for (const key in params) {
    bodyFormData.append(key, params[key]);
  }
  return axios({
    method: "POST",
    url: baseUrl + `users/createClassRoom`,
    data: bodyFormData,
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  })
    .then((res: any) => {
      const response = res.data;
      return response;
    })
    .catch((err: any) => {
      console.log(err, "Get Classroom Error");
    });
}

export async function getClassroom(params: any) {
  const bodyFormData = new FormData();
  for (const key in params) {
    bodyFormData.append(key, params[key]);
  }
  return axios({
    method: "POST",
    url: baseUrl + `users/getClassroomsByEducator`,
    data: bodyFormData,
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  })
    .then((res: any) => {
      const response = res.data;
      return response;
    })
    .catch((err: any) => {
      console.log(err, "Get Classroom Error");
    });
}

export async function deleteClassroom(params: any) {
  const bodyFormData = new FormData();
  for (const key in params) {
    bodyFormData.append(key, params[key]);
  }
  return axios({
    method: "POST",
    url: baseUrl + `users/deleteClassroom`,
    data: bodyFormData,
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  })
    .then((res: any) => {
      const response = res.data;
      return response;
    })
    .catch((err: any) => {
      console.log(err, "Get Delete Classroom Error");
    });
}

export async function deleteStudent(params: any) {
  const bodyFormData = new FormData();
  for (const key in params) {
    bodyFormData.append(key, params[key]);
  }
  return axios({
    method: "POST",
    url: baseUrl + `users/removeStudentfromClass`,
    data: bodyFormData,
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  })
    .then((res: any) => {
      const response = res.data;
      return response;
    })
    .catch((err: any) => {
      console.log(err, "Get Delete Student Error");
    });
}

export async function addStudent(params: any) {
  const bodyFormData = new FormData();
  for (const key in params) {
    bodyFormData.append(key, params[key]);
  }
  // console.log(bodyFormData,params)
  return axios({
    method: "POST",
    url: baseUrl + `users/addStudentsToClassRoom`,
    data: bodyFormData,
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  })
    .then((res: any) => {
      const response = res.data;
      return response;
    })
    .catch((err: any) => {
      console.log(err, "Add Students Error");
    });
}

export async function showStudentPassword(params: any) {
  const bodyFormData = new FormData();
  for (const key in params) {
    bodyFormData.append(key, params[key]);
  }
  return axios({
    method: "POST",
    url: baseUrl + `users/showStudentPassword`,
    data: bodyFormData,
    headers: { "Content-Type": "application/x-www-form-urlencoded" }
  })
    .then((res: any) => {
      const response = res.data;
      return response;
    })
    .catch((err: any) => {
      console.log(err, 'Show Password error');
    });
}

export async function resetStudentPassword(params: any) {
  const bodyFormData = new FormData();
  for (const key in params) {
    bodyFormData.append(key, params[key]);
  }
  return axios({
    method: "POST",
    url: baseUrl + `users/resetStudentPassword`,
    data: bodyFormData,
    headers: { "Content-Type": "application/x-www-form-urlencoded" }
  })
    .then((res: any) => {
      const response = res.data;
      return response;
    })
    .catch((err: any) => {
      console.log(err, 'Reset Password error');
    });
}

export async function generateStudentPassword(params: any) {
  const bodyFormData = new FormData();
  for (const key in params) {
    bodyFormData.append(key, params[key]);
  }
  return axios({
    method: "POST",
    url: baseUrl + `users/generateStudentPassword`,
    data: bodyFormData,
    headers: { "Content-Type": "application/x-www-form-urlencoded" }
  })
    .then((res: any) => {
      const response = res.data;
      return response;
    })
    .catch((err: any) => {
      console.log(err, 'Reset Password error');
    });
}

export async function generateStudentUsername(params: any) {
  const bodyFormData = new FormData();
  for (const key in params) {
    bodyFormData.append(key, params[key]);
  }
  return axios({
    method: "POST",
    url: baseUrl + `users/generateStudentUsername`,
    data: bodyFormData,
    headers: { "Content-Type": "application/x-www-form-urlencoded" }
  })
    .then((res: any) => {
      const response = res.data;
      return response;
    })
    .catch((err: any) => {
      console.log(err, 'Reset Password error');
    });
}

export async function getGoogleClassrooms(params: any) {
  const bodyFormData = new FormData();
  for (const key in params) {
    bodyFormData.append(key, params[key]);
  }
  return axios({
    method: "POST",
    url: baseUrl + `users/getGoogleClassrooms`,
    data: bodyFormData,
    headers: { "Content-Type": "application/x-www-form-urlencoded" }
  })
    .then((res: any) => {
      const response = res.data;
      return response;
    })
    .catch((err: any) => {
      console.log(err, 'Google Classroom error');
    });
}

export async function getCleverClassrooms(params: any) {
  const bodyFormData = new FormData();
  for (const key in params) {
    bodyFormData.append(key, params[key]);
  }
  return axios({
    method: "POST",
    url: baseUrl + `users/getCleverClassrooms`,
    data: bodyFormData,
    headers: { "Content-Type": "application/x-www-form-urlencoded" }
  })
    .then((res: any) => {
      const response = res.data;
      return response;
    })
    .catch((err: any) => {
      console.log(err, 'Google Classroom error');
    });
}

export async function googleClassroomSync(params: any) {
  const bodyFormData = new FormData();
  for (const key in params) {
    bodyFormData.append(key, params[key]);
  }
  return axios({
    method: "POST",
    url: baseUrl + `users/googleClassroomSync`,
    data: bodyFormData,
    headers: { "Content-Type": "application/x-www-form-urlencoded" }
  })
    .then((res: any) => {
      const response = res.data;
      return response;
    })
    .catch((err: any) => {
      console.log(err, 'Google Classroom Sync error');
    });
}

export async function getAvatarName(params: any) {
  const bodyFormData = new FormData();
  for (const key in params) {
    bodyFormData.append(key, params[key]);
  }
  return axios({
    method: "POST",
    url: baseUrl + `users/getAvatarName`,
    data: bodyFormData,
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  })
    .then((res: any) => {
      const response = res.data;
      return response;
    })
    .catch((err: any) => {
      console.log(err, "getAvatarNameError");
    });
}

export async function saveAvatarName(params: any) {
  const bodyFormData = new FormData();
  for (const key in params) {
    bodyFormData.append(key, params[key]);
  }
  return axios({
    method: "POST",
    url: baseUrl + `users/saveAvatarName`,
    data: bodyFormData,
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  })
    .then((res: any) => {
      const response = res.data;
      return response;
    })
    .catch((err: any) => {
      console.log(err, "saveAvatarNameError");
    });
}